import {
  MATIC_BAG_PASS_PRODUCT_ID,
  MATIC_BAG_PASS_VARIANT_ID,
  MATIC_CARE_PRODUCT_ID,
  MATIC_CARE_VARIANT_ID,
  MATIC_REFERRAL_BAG_PASS_PRODUCT_ID,
  MATIC_REFERRAL_BAG_PASS_VARIANT_ID,
  MATIC_REFKIT_VARIANT_ID,
  MATIC_STICKER_KIT_PRODUCT_ID,
  MATIC_STICKER_KIT_VARIANT_ID,
} from "../consts/shopify";
import { isMaticFamilyProductId, isMaticFamilyVariantId } from "./maticFamily";

type MerchandiseNode =
  | {
      merchandise?: {
        id?: string | null;
        product?: { id?: string | null } | null;
      } | null;
    }
  | null
  | undefined;

export const formatPrice = (amount: number | string, currency = "USD") => {
  const price = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(Number(amount));

  return price;
};

export const isInStock = (
  quantity: number | null,
  availableForSale: boolean,
) => {
  if (quantity === null) return availableForSale;

  return availableForSale && quantity > 0;
};

export const isMatic = (node: MerchandiseNode) => {
  return (
    isMaticFamilyProductId(node?.merchandise?.product?.id) ||
    isMaticFamilyVariantId(node?.merchandise?.id)
  );
};

export const isLegacyReferralReward = (node: MerchandiseNode) => {
  return node?.merchandise?.id === MATIC_REFKIT_VARIANT_ID;
};

export const isStandardBagPass = (node: MerchandiseNode) => {
  return (
    node?.merchandise?.product?.id === MATIC_BAG_PASS_PRODUCT_ID ||
    node?.merchandise?.id === MATIC_BAG_PASS_VARIANT_ID
  );
};

export const isReferralRewardBagPass = (node: MerchandiseNode) => {
  return (
    node?.merchandise?.product?.id === MATIC_REFERRAL_BAG_PASS_PRODUCT_ID ||
    node?.merchandise?.id === MATIC_REFERRAL_BAG_PASS_VARIANT_ID
  );
};

export const isBagPass = (node: MerchandiseNode) => {
  return isStandardBagPass(node) || isReferralRewardBagPass(node);
};

export const isMaticCare = (node: MerchandiseNode) => {
  return (
    node?.merchandise?.product?.id === MATIC_CARE_PRODUCT_ID ||
    node?.merchandise?.id === MATIC_CARE_VARIANT_ID
  );
};

export const isStickerKit = (node: MerchandiseNode) => {
  return (
    node?.merchandise?.product?.id === MATIC_STICKER_KIT_PRODUCT_ID ||
    node?.merchandise?.id === MATIC_STICKER_KIT_VARIANT_ID
  );
};

export function getSafeUrl(rawUrl?: string) {
  if (!rawUrl) return null;

  const trimmedUrl = rawUrl.trim();
  if (!trimmedUrl) return null;

  if (trimmedUrl.includes('"') || trimmedUrl.includes("'")) {
    return null;
  }

  if (/^https?:\/\//i.test(trimmedUrl) || /^mailto:/i.test(trimmedUrl)) {
    return { href: trimmedUrl, isExternal: true };
  }

  if (/^www\./i.test(trimmedUrl)) {
    return { href: `https://${trimmedUrl}`, isExternal: true };
  }

  if (
    (trimmedUrl.startsWith("/") &&
      !trimmedUrl.startsWith("//") &&
      !trimmedUrl.startsWith("/\\")) ||
    trimmedUrl.startsWith("#")
  ) {
    return { href: trimmedUrl, isExternal: false };
  }

  return null;
}
